/**
 * The do-not-contact list's sources, and how loudly each one reads.
 *
 * React-free on purpose. Two lists have to agree with the server here - the
 * options the filter offers and the tone each row is drawn in - and a test can
 * only hold them together if it can import them without pulling in a component
 * tree and its stylesheets.
 *
 * The list itself is NOT redefined: it comes from `@wa/core`, which is also
 * where the server's own validation reads it from. What lives here is the one
 * thing the interface adds, which is the colour.
 */
import { MKT_SUPPRESSION_SOURCES } from "@wa/core/marketing-suppression";
import type { StatusTone } from "../../../ui/StatusPill";

export const SUPPRESSION_SOURCES = MKT_SUPPRESSION_SOURCES;

/**
 * How loudly each source reads.
 *
 * A complaint is the strongest thing on this page - somebody reported us - so it
 * gets the refusal tone. An unsubscribe is the recipient's own decision and
 * equally permanent, but it is a normal, expected outcome rather than a fault,
 * so it is amber and not red. A bounce is the mail system's verdict rather than
 * a person's, and hand-added rows are ours; neither is a judgement about us. An
 * erasure is the strongest REQUEST: everything else about that person is
 * already gone and this row is what is left of it.
 *
 * Every source needs an entry. A missing one does not fail - it falls to the
 * muted default, so the loudest row on the page would draw as the quietest.
 */
export const SOURCE_TONE: Record<string, StatusTone> = {
  complaint: "lt",
  unsubscribe: "wt",
  bounce: "mut",
  manual: "info",
  import: "mut",
  erasure: "lt",
};
